let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2s3c1")).then(() => parcelRequire('hZT3b'));